import React, { createContext, useEffect, useState } from "react";
const getlocalStorageItem = () => {
  let userId = localStorage.getItem("WFL_ID");
  if (userId) {
    return JSON.parse(userId);
  } else {
    // console.log("is ok")

    return null;
  }
};

export const AuthContext = createContext("");

const AuthProvider = ({ children }) => {
  const [authId, setAuthId] = useState(getlocalStorageItem());
  const [authUser, setUser] = useState(null);
  const [token, setToken] = useState(getCookie("WFL_token"));
  const [loading, setLoading] = useState(true);

  const LoginWithEmail = (data) => {
    setAuthId(data);
    // console.log("context api : ", data);
  };

  function getCookie(name) {
    const cookieValue = document.cookie.match(
      `(^|;)\\s*${name}\\s*=\\s*([^;]+)`
    );
    return cookieValue ? cookieValue.pop() : "";
  }


  useEffect(() => {
    if (authId) {
      fetch(`https://api.wlffinance.org/api/user/auth/view/${authId?.user_id}`, {
        method: "GET",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data?.success === false) {
            SignOut();
            return;
          } else {
            setUser(data.data);
            setLoading(false);
          }
        });
    } else {
      SignOut();
      setLoading(false);
      return;
    }
  }, [authId]);
  const SignOut = () => {
    document.cookie = `WFL_token=; expires=${new Date(
      0
    ).toUTCString()}; path=/`;
    localStorage.removeItem("WFL_ID");
    const data = null;
    LoginWithEmail(data);
  };

  //// theme

  const [theme, setTheme] = useState("dark");

  const applyTheme = (theme) => {
    document.body.setAttribute("data-theme", theme);
    document.body.style.colorScheme = theme;
    localStorage.setItem("wlf-theme", theme);
  };

  useEffect(() => {
    const savedTheme = localStorage.getItem("wlf-theme");
    const initialTheme = savedTheme || "dark";
    setTheme(initialTheme);
    applyTheme(initialTheme);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    applyTheme(newTheme);
  };

  //// theme  end
  const authInfo = {
    authUser,
    LoginWithEmail,
    setUser,
    token,
    theme,
    toggleTheme,
    authId,
    loading
  };
  if (loading) {
    return<></>;
  }
  return (
    <AuthContext.Provider value={authInfo}>{children}</AuthContext.Provider>
  );
};

export default AuthProvider;
